module.exports = __webpack_public_path__ + "img/default-thumbnail.cfa92389.svg";